export const SET_IS_LOADING = 'SET_IS_LOADING';
export const SET_GLOBALS = 'SET_GLOBALS';
export const FETCH_GLOBALS = 'FETCH_GLOBALS';
export const SET_GLOBAL_ERROR = 'SET_GLOBAL_ERROR';
export const SET_PAGE_DATA = 'SET_PAGE_DATA';
export const SET_LANGUAGE_DATA = 'SET_LANGUAGE_DATA';
export const SET_USER = 'SET_USER';
export const SET_CAN_SCROLL = 'SET_CAN_SCROLL';
